module.exports = function getResource(label, vars = []) {
    let resources = {
        edit: 'Edit'
    };
    return resources[label];
};
